import React, { useEffect, useContext, useState } from 'react';
import { useCart } from '../../context/CartContext';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { LanguageContext } from '../../Component/LanguageContext/LanguageContext';
import styles from './Cart.module.css';
//Cart component to display items in the shopping cart
const Cart = () => {
  const { cart, loading, error, removeFromCart, fetchCart } = useCart();
  const navigate = useNavigate();
  const { direction } = useContext(LanguageContext);
  const [isLoading, setIsLoading] = useState(true);
  const [loadingItems, setLoadingItems] = useState(new Set());

  useEffect(() => {
    const initializeCart = async () => {
      try {
        const userEmail = localStorage.getItem("useremailidis");
        // Do not redirect guest users to login; allow guest cart
        
        console.log("Initializing cart...");
        setIsLoading(true);
        await fetchCart();
        console.log("Cart data received:", cart);
      } catch (error) {
        console.error('Error initializing cart:', error);
      } finally {
        setIsLoading(false);
      }
    };

    initializeCart();
  }, []);

  const handleRemoveItem = async (productId) => {
    try {
      setLoadingItems(prev => new Set([...prev, productId]));
      await removeFromCart(productId);
    } catch (error) {
      console.error('Error removing item:', error);
    } finally {
      setLoadingItems(prev => {
        const newSet = new Set(prev);
        newSet.delete(productId);
        return newSet;
      });
    }
  };

  const handleCheckout = () => {
    navigate('/home/cart-checkout');
  };

  const getItemPrice = (item) => direction === 'rtl' ? (item.priceArabic || item.price || 0) : (item.priceEnglish || item.price || 0);

  if (isLoading || loading) {
    return <div className={styles.loadingSpinner}>Loading...</div>;
  }

  if (error) {
    return <div className={styles.errorMessage}>{error}</div>;
  }

  if (!cart?.items?.length) {
    return (
      <div className={styles.cartContainer}>
        {/* <h1 className={styles.cartTitle}>
          {direction === 'rtl' ? 'سلة التسوق فارغة' : 'Your cart is empty'}
        </h1> */}
        <p className={styles.emptyCartMessage}>
          {direction === 'rtl' 
            ? 'لا توجد دورات في سلة التسوق الخاصة بك' 
            : 'Your cart is currently empty. Browse courses to get started!'}
        </p>
        <div style={{ display: 'flex', justifyContent: 'center' }}>
        <button 
          className={styles.browseCoursesButton}
            onClick={() => navigate('/home/R2/R3/prc/All')}
        >
            {direction === 'rtl' ? 'تصفح الدورات' : 'Browse Courses'}
        </button>
        </div>
      </div>
    );
  }

  const total = cart.items.reduce((sum, item) => sum + parseFloat(getItemPrice(item)), 0);

  return (
    <div className={styles.cartContainer}>
      <div className={styles.cartHeader}>
        <h1 className={styles.cartTitle}>
          {direction === 'rtl' ? 'سلة التسوق' : 'Shopping Cart'}
        </h1>
      </div>

      <div className={styles.cartItems}>
        {[...cart.items].reverse().map((item) => (
          <div key={item.productId} className={styles.cartItem}>
            <img 
              src={item.thumbnail || item.image || "https://maflamlmsnew.s3.me-central-1.amazonaws.com/marketingphotos/default-course.png"}
              alt={direction === 'rtl' 
                ? (item.courseNameArabic || item.nameArabic || item.courseName || item.name)
                : (item.courseNameEnglish || item.nameEnglish || item.courseName || item.name)}
              className={styles.itemImage}
            />
            <div className={styles.itemDetails}>
              <h3 className={styles.itemName}>{
                direction === 'rtl'
                  ? (item.courseNameArabic || item.nameArabic || item.courseName || item.name)
                  : (item.courseNameEnglish || item.nameEnglish || item.courseName || item.name)
              }</h3>
              {(direction === 'rtl'
                ? (item.descriptionArabic || item.description)
                : (item.descriptionEnglish || item.description)) && (
                <p className={styles.itemDescription}>
                  {direction === 'rtl'
                    ? (item.descriptionArabic || item.description)
                    : (item.descriptionEnglish || item.description)}
                </p>
              )}
              <p className={styles.itemPrice}>
                {direction === 'rtl'
                  ? `${getItemPrice(item)} ريال سعودي`
                  : `SAR ${getItemPrice(item)}`}
              </p>
            </div>
            <button
              className={styles.removeButton}
              onClick={() => handleRemoveItem(item.productId)}
              disabled={loadingItems.has(item.productId)}
            >
              {direction === 'rtl' ? 'حذف' : 'Remove'}
            </button>
          </div>
        ))}
      </div>

      <div className={styles.priceSummary}>
        <div className={styles.summaryRow}>
          <span className={styles.summaryLabel}>
            {direction === 'rtl' ? 'المجموع' : 'Total'}
          </span>
          <span className={styles.summaryValue}>
            {direction === 'rtl' ? `${total} ريال سعودي` : `SAR ${total}`}
          </span>
        </div>
      </div>

      <div className={styles.totalSection}>
        <div style={{ display: 'flex', gap: '16px', padding: '16px' }}>
          <button
            className={styles.browseCoursesButton}
            onClick={() => navigate('/home/R2/R3/prc/All')}
          >
            {direction === 'rtl' ? 'تصفح الدورات' : 'Browse Courses'}
          </button>
        <button 
          className={styles.browseCoursesButton}
          onClick={handleCheckout}
        >
          {direction === 'rtl' ? 'الدفع' : 'Checkout'}
        </button>
        </div>
      </div>
    </div>
  );
};

export default Cart; 